export default __webpack_public_path__ + "static/media/1.5bb7e7a2.png";